const environment = {
  apiUrl: "https://api.fipay.io",
  graphql: "https://api.fipay.io/graphql",
  joinWaitlistTempId: "100",
  joinSubscriptionTempId: "100",
  publishableKey:
    "pk_test_51N5RwtFMwL8QZRPTX7xohghqvcavgyEvsSWcsucw0zTtiJsx8ElhsSgTTdqAwyJWgk63BfEOmqPPnLtuL2nHIo3X00TLF8PxZ3",
};
export default environment;

// apiUrl: " https://ta3dqci849.execute-api.us-east-1.amazonaws.com",
// graphql: " https://ta3dqci849.execute-api.us-east-1.amazonaws.com/dev/graphql",
